// 0 componentBottom: '2px -4px 16px 0 rgba(0, 0, 0, 0.06)',
// 1 componentTop: '2px 4px 16px 0 rgba(0, 0, 0, 0.06)',
// 2 fab: '0 1px 1px 0 rgba(0, 0, 0, 0.14)',
// 3 filter: '6px 12px 40px 0 rgba(0, 0, 0, 0.10)',
// 4 high: '6px 12px 40px 3px rgba(0, 0, 0, 0.20)',
// 5 low: '4px 8px 16px 0 rgba(0, 0, 0, 0.08)',
// 6 medium: '4px 8px 24px 1px rgba(0, 0, 0, 0.08)',
// 7 menu: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)
// 8 accordion: inset 0 -1 0 #E4E4E4,
// 9 new contained button styles from Figma
// 10 new contained (hover) button styles from Figma
// 11 new shadow for cards from Figma

const shadows = [
  '2px -4px 16px 0 rgba(0, 0, 0, 0.06)',
  '2px 4px 16px 0 rgba(0, 0, 0, 0.06)',
  '0 1px 1px 0 rgba(0, 0, 0, 0.14)',
  '6px 12px 40px 0 rgba(0, 0, 0, 0.10)',
  '6px 12px 40px 3px rgba(0, 0, 0, 0.20)',
  '4px 8px 16px 0 rgba(0, 0, 0, 0.08)',
  '4px 8px 24px 1px rgba(0, 0, 0, 0.08)',
  '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
  'inset 0px -1px 0px #E4E4E4',
  // FIGMA SHADOWS
  '0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)',
  '0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 2px 4px -1px rgba(0, 0, 0, 0.20)',
  '0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.20)',
  ...Array(14).fill('none'), // TODO: probably need some more shadows for the new Figma design, but we can add them as we go
];

export default shadows;
